import React, {useEffect, useState} from 'react';
import {VStack} from 'native-base';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {InvoiceCandidateListItem} from './components';

import {StackParamList} from '../../../../../../../navigators';
import InternalTemplate from '../../../../../../../components/templates/internal';
import IInvoiceCandidate from '../../../../../../../interfaces/dtos/invoice-candidate-list.interface';
import {EmptyListIcon} from '../../../../../../../components/icons';
import {SpinnerModal} from '../../../../../../../components/modals';
import {useSalesmanContext} from '../../../../../../../context/salesman';

type ScreenProps = NativeStackScreenProps<
  StackParamList,
  'InvoiceCandidateList'
>;

const InvoiceCandidateList = ({navigation}: ScreenProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const {fetchInvoiceCandidates, invoiceCandidates, setInvoiceCandidate} =
    useSalesmanContext();
  const [list, setList] = useState([] as IInvoiceCandidate[] | null);

  const fill = async () => {
    setIsLoading(true);
    await fetchInvoiceCandidates();
    setIsLoading(false);
  };

  useEffect(() => {
    fill();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setList(invoiceCandidates);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceCandidates]);

  const handleGoBack = () => {
    navigation.goBack();
  };

  const handleSelectItem = (index: number) => {
    if (list && list.length) {
      const request = list[index];
      request.dateAt = new Date().toISOString();
      setInvoiceCandidate(request);
      navigation.navigate('InvoiceAdjustableItems');
    }
  };

  function isOdd(num: number) {
    return num % 2;
  }

  const showContent = () => {
    if (isLoading) {
      return <></>;
    }
    if (list === null || list?.length === 0) {
      return <EmptyListIcon />;
    }

    return (
      list &&
      list.map((item: IInvoiceCandidate, index: number) => (
        <InvoiceCandidateListItem
          key={`balance-item-${index}`}
          item={item}
          onPress={() => handleSelectItem(index)}
          rowType={isOdd(index) ? 'odd' : 'even'}
        />
      ))
    );
  };

  return (
    <InternalTemplate
      title={'salesman-invoice-candidates-title'}
      contentPaddingX="0"
      backButton={{
        onPress: () => handleGoBack(),
        label: 'go-back',
        usage: 'external',
      }}>
      <SpinnerModal show={isLoading} />
      <VStack justifyContent="flex-start">{showContent()}</VStack>
    </InternalTemplate>
  );
};

export default InvoiceCandidateList;
